<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>PERSONEL GÜNCELLEME EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">PERSONEL GÜNCELLEME EKRANI</a></li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">PERSONEL GÜNCELLEME EKRANI</h3>

            <div class="tile-body">
              <form>
                <div class="form-group">
                  <label class="control-label">Personel Adı</label>
                  <span
                    style="background-color: rgb(253, 109, 73);"
                    class="form-control"
                    >{{resultpersonel.name + "  " +  resultpersonel.surname}}</span
                  >
                </div>
                <div class="form-group">
                  <label class="control-label">Telefon Numarası</label>
                  <input
                    v-model="resultpersonel.tel"
                    class="form-control"
                    type="text"
                    placeholder="Telefon No Gİriniz"
                    style="background-color: rgb(127, 238, 132);"
                  />
                </div>

                <div class="form-group">
                  <label class="control-label">İşe Giriş Tarihi Güncelleme</label>
                  <input
                    v-model="resultpersonel.isegiris"
                    class="form-control"
                    type="date"
                    placeholder="Delgi Çapı"
                    style="background-color: rgb(127, 238, 132);"
                  />
                </div>
             
              </form>
            </div>

            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-success" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Güncelle
              </button>
              <button @click="statusone()" class="btn btn-danger" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>ASKIYA AL
              </button>
              <button @click="statuszero()" class="btn btn-info" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>AKTİFLEŞTİR
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      // saha: "",
      makinaId: "",
      name: "",
      surname: "",
      tel: "",
      isegiris: "",
      resultpersonel: [],
      personel_id: this.$route.query.id,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var datas = {
      personelId: this.personel_id,
    };
    let dataUrl =
      store.state.base_url + "AslanSahalar/getByIdPersonel.php?key=123";
    axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
      this.resultpersonel = response.data;
    });
  },
  methods: {
    // changesaha(event) {
    //   this.saha = event.target.value;
    // },
    statusone() {
      var dataStatus = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        personel_id: this.personel_id,
      };
      let dataUrl3 =
        store.state.base_url + "AslanSahalar/personelstatusone.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        this.$swal({
          text: "PERSONEL BAŞARIYLA KALDIRILDI",
          icon: "success",
          closeOnClickOutside: false,
        });
      });
    },
    statuszero() {
      var dataStatus = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        personel_id: this.personel_id,
      };
      let dataUrl3 =
        store.state.base_url + "AslanSahalar/personelstatuszero.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        if (response.data == true) {
          this.$swal({
            text: "PERSONEL BAŞARIYLA GERİ YÜKLENDİ",
            icon: "success",
            closeOnClickOutside: false,
          });
        }
      });
    },
    reload: function() {
      location.reload();
    },
    sendData: function() {
        var url = store.state.base_url + "AslanSahalar/updatePersonel.php?key=123";
        var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          tel: this.resultpersonel.tel,
          isegiris: this.resultpersonel.isegiris,
          personel_id: this.personel_id,
        };

        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data.data == true) {
              this.$swal({
                text: "Güncelleme İşleminiz Başarıyla Gerçekleştirildi!",
                icon: "success",
                closeOnClickOutside: true,
              });
              // setTimeout(function() {location.reload()},1250);

            } else {
              this.$swal({
                text: "Hata Oluştu!",
                icon: "error",
                closeOnClickOutside: false,
              });
            }

            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UpdatePersonel.vue